import * as React from "react";
import { useAppDispatch, useAppSelector } from "app/store";
import * as Actions from "./store/userSetup.actions";
import { selectAuthUserID } from "app/auth/store/auth.slice";

export const UserSetup = React.createContext({});

const initialParams = {
  pagina: 1,
  itensPorPagina: 300,
};

const UserSetupProvider = ({ children }) => {
  const dispatch = useAppDispatch();
  const USER_ID = useAppSelector(selectAuthUserID);
  const token = sessionStorage.getItem('AccessToken');

  React.useEffect(() => {
    if (!token || !USER_ID) return;
    dispatch(Actions.getUserSetup({idUsuario: USER_ID, ...initialParams}));
  }, [USER_ID, token]);

  return <UserSetup.Provider value={{}}>{children}</UserSetup.Provider>;
};

export default UserSetupProvider;
